export default {
  state: {
    id: undefined,
    name: undefined,
    slug: undefined,
    description: undefined,
    authentication_token: undefined,
    app_names: undefined,
    inactive: true,
    visible: false,
    created_at: undefined,
    updated_at: undefined,
    relationships: {},
    apps: []
  }
}



// WEBPACK FOOTER //
// ./src/stores/PartnerStore.js